export const clamp = (
  value: number,
  min?: number | undefined,
  max?: number | undefined
) => {
  if (min !== undefined && max !== undefined && min > max) {
    throw new Error(`expected min < max. got min=${min}, max=${max}`);
  }
  if (min !== undefined) {
    value = Math.max(min, value);
  }
  if (max !== undefined) {
    value = Math.min(max, value);
  }
  return value;
};
